import { useMemo } from "react";
import { number } from "zod";
import {
  TextH3,
  TextSecondary,
} from "../../components/DesignSystem/DesignSystemText";

interface Props {
  count: number;
  description: string;
}

const CommunityStat = ({ count, description }: Props) => {
  const formatter = Intl.NumberFormat("en", { notation: "compact" });
  const formmatedCount = useMemo(() => {
    return formatter.format(count);
  }, [count, formatter]);

  return (
    <div className="text-center">
      <TextH3>{formmatedCount}</TextH3>
      <TextSecondary>{description}</TextSecondary>
    </div>
  );
};

export default CommunityStat;
